<template>
    <div id="app">
        <main><router-view/></main>
    </div>
</template>

<script>
export default {
    name: "App"
};
</script>
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  flex-direction: column;
  align-items: stretch ; 
  margin-top: -0px !important;
}
main{
  flex-grow: 2;
  overflow-y: auto;
  height: 100%;
}
</style>